import DateRangePicker from "daterangepicker"


$(function () {
  function getStartOfMonthAgo(monthsAgo) {
    const currentDate = new Date();
    currentDate.setMonth(currentDate.getMonth() - monthsAgo);
    return new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
  }

// Get date for the end of a specific month relative to the current month
  function getEndOfMonthAgo(monthsAgo) {
    const currentDate = new Date();
    currentDate.setMonth(currentDate.getMonth() - monthsAgo + 1);
    return new Date(currentDate.getFullYear(), currentDate.getMonth(), 0);
  }

// Define the ranges for the last 6 months with named months and year
  const ranges = {};

  for (let i = 0; i <= 5; i++) { // Include the current month (0) and the past 5 months
    const startOfMonth = getStartOfMonthAgo(i);
    const endOfMonth = getEndOfMonthAgo(i);
    const monthName = new Intl.DateTimeFormat('en-US', {year: 'numeric', month: 'long'}).format(startOfMonth);

    ranges[monthName] = [startOfMonth, endOfMonth];
  }

  const nodeList = document.querySelectorAll('[data-toggle="daterangepicker"]');
  Array.from(nodeList).forEach(element => {

    let options = {}

    if (element.dataset.monthranges) {
      options = {
        ranges: ranges
      }
    } else if (element.dataset.ranges) {
      let json = JSON.parse(element.dataset.ranges)
      for (const key in json) {
        if (json.hasOwnProperty(key)) {
          const range = json[key];
          range[0] = new Date(range[0]);
          range[1] = new Date(range[1]);

          // Set range[0] to the beginning of the month
          range[0].setDate(1);
          range[0].setHours(0, 0, 0, 0);

          // Set range[1] to the end of the month
          range[1].setDate(1);
          range[1].setMonth(range[1].getMonth() + 1);
          range[1].setHours(0, 0, 0, -1);
        }
      }
      options = {
        ranges: json
      }
    }

    const el = new DateRangePicker(element, options)

    if (element.dataset.autosubmit) {
      el.element.on('apply.daterangepicker', function (e) {
        el.element.parent('form').submit()
      })
    }
  })
});